<template>
  <v-layout row>
    <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4 mt-12>
      <v-card class="mt-12">
        <v-card-title primary-title>
          <h3 class="headline mb-0 primary--text">
            Bienvenue sur la plateforme de gestion des acteurs de ACMA 2
          </h3>
        </v-card-title>
        <v-card-text> </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "join-view",
  layout: "default",
  data: () => ({
    token: "",
  }),
  created() {
    this.token = this.$route.params.token;
    this.checkInvitation();
  },

  methods: {
    async checkInvitation() {
      const { data } = await axios.get("/api/invitation/check/" + this.token);
      if (data.roles[0].name === "application") {
        // Redirect to the developer register .
        this.$router.push({ name: "developer", params: { token: this.token } });
      } else {
        // Redirect to register.
        this.$router.push({ name: "register", params: { token: this.token } });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/join.vue